import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { App } from '@capacitor/app';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { NetworkService } from './network.service';
import { HttpService } from './http.service';
import { TranslationService } from './translation.service';
import { DataService } from './data.service';
import { Device } from '@capacitor/device';
import { StorageService } from './storage.service';
import AppConstants from '../constants/app.constants';
import * as forge from 'node-forge';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  lang: any = '';
  player_id: any = '';
  userid: any = '';
  deviceInfo: any;
  appVersion: any;
  payload_data_public_key: any;
  authToken = new BehaviorSubject('');

  constructor(
    private http: HttpClient,
    private TranslationService: TranslationService,
    private networkconnectionservice: NetworkService,
    private httpService: HttpService,
    private dataService: DataService,
    private storageService: StorageService
  ) {
    this.getLanguage();
  }

  getLanguage() {
    this.lang = this.TranslationService.getSelectedLang();
  }

 

  async loginUser(user: any) {
    user.device_name = this.deviceInfo.platform;

    user.player_id =  this.deviceInfo.uuid

    if (this.deviceInfo.operatingSystem === 'android') {
      user.device_type = 1;
    } else if (this.deviceInfo.operatingSystem === 'ios') {
      user.device_type = 0;
    } else {
      user.device_type = 2;
    }

    user.language =   this.storageService.getItem(AppConstants.SELECTED_LANGUAGE);

    user.version = this.appVersion
      ? this.appVersion
      : this.deviceInfo.webViewVersion;

    return this.httpService.postAuth('auth/user/loginUser', user);
  }

  verifyUserWithToken(user: any) {
    return this.httpService.postAuth('auth/user/verify-rw-auth-token', user);
  }

  encryptPayload(payload: any) {
    const aesKey = forge.random.getBytesSync(32);  
    const iv = forge.random.getBytesSync(12);    
 
    const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(forge.util.encodeUtf8(JSON.stringify(payload))));
    cipher.finish();
 
    const encryptedData = forge.util.encode64(cipher.output.getBytes());
    const authTag = forge.util.encode64(cipher.mode.tag.getBytes());
 
    const publicKeyAlt = this.payload_data_public_key;  
    const publicKey1 = publicKeyAlt.replace(/\\n/g, '\n');
    const publicKey = forge.pki.publicKeyFromPem(publicKey1);  
    const encryptedKey = publicKey.encrypt(aesKey, 'RSA-OAEP');
 
    const encKeyStr = forge.util.encode64(encryptedKey); 
    const encIvStr = forge.util.encode64(iv);             
    const encAuthTagStr = authTag;                        
 
    const allStr = `${encKeyStr}:${encIvStr}:${encAuthTagStr}:${encryptedData}`;
    let encryptdata = {
      data: allStr
    }
    return encryptdata;
  }

  decryptPayload(encryptedObj: any, privateKeyPem: string): any {
  try {
    const [encKeyStr, encIvStr, encAuthTagStr, encryptedData] = encryptedObj.data.split(':');

    const encryptedKey = forge.util.decode64(encKeyStr);
    const iv = forge.util.decode64(encIvStr);
    const authTag = forge.util.decode64(encAuthTagStr);
    const encryptedBytes = forge.util.decode64(encryptedData);

    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);

    const aesKey = privateKey.decrypt(encryptedKey, 'RSA-OAEP');

    const decipher = forge.cipher.createDecipher('AES-GCM', aesKey);
    decipher.start({
      iv: iv,
      tag: forge.util.createBuffer(authTag),
    });

    decipher.update(forge.util.createBuffer(encryptedBytes));

    const success = decipher.finish();
    if (!success) throw new Error('Decryption failed: Auth tag mismatch');

    const decryptedStr = decipher.output.toString();
    return JSON.parse(decryptedStr);

  } catch (err) {
    console.error('Decryption error:', err);
    return null;
  }
}


  async getStaticContent(user: any, type: any) {
    const payload = { lang: user };
    const status = this.networkconnectionservice.networkStatus.value;

    const key = `STATIC_CONTENT_${type}`; 

    if (status === true) {
      try {
        const result = await this.dataService.smartFetch(key, () => {
          return firstValueFrom(
            this.http.post(
              environment.apiUrl + 'user/entity/getStaticContent/' + type,
              payload
            )
          );
        });

        return result;
      } catch (error) {
        console.error('Static content fetch error:', error);
        throw error;
      }
    } else {
      const local = await this.dataService.getFromLocal(key);
      if (local?.data) return local.data;
      else throw new Error('Offline mode: static content not available');
    }
  }

  forgotPassword(data: any) {
    data.language = this.lang;
    return this.httpService.postAuth('auth/user/forgotPassword', JSON.stringify(data));
  }
}
